"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Instagram, Twitter, Facebook, Pin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <>
        <div className="space-y-4">
          <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          <div className="h-4 w-32 bg-muted animate-pulse rounded-md" />
          <div className="h-4 w-28 bg-muted animate-pulse rounded-md" />
        </div>
        <div className="space-y-4">
          <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          <div className="h-4 w-32 bg-muted animate-pulse rounded-md" />
          <div className="h-4 w-28 bg-muted animate-pulse rounded-md" />
        </div>
      </>;
  }
  const hasChildren = menuItems.some(item => item.children && item.children.length > 0);
  if (hasChildren) {
    return <>
        {menuItems.slice(0, 2).map((column, i) => <div key={column.id} data-index={i}>
            <h4 className="font-default font-medium text-sm tracking-wide uppercase mb-6 text-foreground">
              {column.label}
            </h4>
            <ul className="space-y-4">
              {column.children?.map((child, j) => <li key={child.id} data-index={j}>
                  <Link to={child.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                    {child.label}
                  </Link>
                </li>)}
            </ul>
          </div>)}
      </>;
  }
  const midPoint = Math.ceil(menuItems.length / 2);
  const col1 = menuItems.slice(0, midPoint);
  const col2 = menuItems.slice(midPoint);
  return <>
      <div>
        <h4 className="font-default font-medium text-sm tracking-wide uppercase mb-6 text-foreground">
          Shop
        </h4>
        <ul className="space-y-4">
          {col1.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
      <div>
        <h4 className="font-default font-medium text-sm tracking-wide uppercase mb-6 text-foreground">
          Company
        </h4>
        <ul className="space-y-4">
          {col2.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
    </>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Pin,
    href: "#",
    label: "Pin"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <section id="footer" className="bg-secondary text-secondary-foreground pt-20 pb-10 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="col-span-1 flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/sunday_velvet_monogram_dark.png" alt="Sunday Velvet" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Elevated daily rituals with luxurious, skin-friendly products for women and boutique spaces.
            </p>
          </div>

          {}
          <MenuProvider menu_id="25" className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-12 lg:gap-8">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="col-span-1">
            <h4 className="font-default font-medium text-sm tracking-wide uppercase mb-6 text-foreground">
              Connect
            </h4>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} aria-label={social.label} className="text-muted-foreground hover:text-foreground transition-colors" data-index={i}>
                    <Icon strokeWidth={1} className="w-5 h-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="bg-border/60 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          <p>&copy; {currentYear} Sunday Velvet. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}